<template>
  <p :class="`hover-tips-${position}`" :style="tipsStyle">
    <!-- <HoverTips position="left" position_left="-100" :content="`分类title写法：一般是“分类名称-导航栏目名称-网站名称”；`"></HoverTips>
    <HoverTips position="right" :content="`分类title写法：一般是“分类名称-导航栏目名称-网站名称”；`"></HoverTips> -->
    <el-popover
      placement="top-start"
      :width="300"
      trigger="hover"
      popper-class="popover_style"
      :content="content"
      transition="zoom"
    >
      <span
        class="icon_info"
        slot="reference"
      >?</span>
    </el-popover>
  </p>
</template>
<script>
import i18n from '../../language/index'

export default {
  props: {
    content: {
      type: String,
      default: i18n.t('components_hovertips_index_2198')
    },
    position: {
      type: String,
      default: 'right'
    },
    position_left: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    };
  },
  watch: {
  },
  components: {
  },
  computed: {
    tipsStyle() {
      let style = {}
      if(this.position == 'left') {
        style = {
          left: this.position + 'px'
        }
      }
      return style
    }
  },
  created() {
  },
  methods: {
  },
  watch: {
  },
};
</script>

<style lang="scss" scoped>
.hover-tips-left {
  left: -99px;
  position: absolute;
  width: 30px;
  top: 10%;
  z-index: 999;
}
.hover-tips-right {
  display: inline-block;
  width: 30px;
  margin-left: 10px;
}
.icon_info {
  border: 1px solid #cfd3db;
  color: #cfd3db;
  width: 18px;
  font-size: 13px;
  height: 18px;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  line-height: 18px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/hoverTips/index.vue